/* eslint-disable no-restricted-globals */
import React, { useState, useEffect } from "react";
import "@/components/less/common.less";
import "@/pages/admin/index.less";
//语言切换
import intl from "react-intl-universal";
import {
  Divider,
  Row,
  Col,
  Select,
  Input,
  InputNumber,
  Image,
  Modal,
  Button,
  Tooltip,
} from "antd";
import {
  PlusOutlined,
  DeleteTwoTone,
  CloseCircleFilled,
  CloudUploadOutlined,
} from "@ant-design/icons";
import { AudioTypeList, ImageTypeList, VideoTypeList } from "../constant.js";
import checkboxImg from "@/assets/checkbox.png";
import radioImg from "@/assets/radio.png";
import TextArea from "antd/lib/input/TextArea.js";
import AliyunOSSUpload from "@/components/AliyunOSSUpload";
import AudioItem from "./audio/audio.jsx";
import Wave from "./waveSurfer/wave.jsx";
import { cloneDeep } from "lodash";

const { Option } = Select;

/**
 * status：渲染当前组件得状态【add,singleRdit,preview,exam,examResult】
 * add: 创建传统题目，批量添加题目，当前题目为编辑状态，非当前题目为非编辑状态，----编辑状态下可切换选项，修改字段correctAnswer，选中选项设置选项为正确答案
 * singleEdit：单个编辑题目，为编辑状态----编辑状态下可切换选项，修改字段correctAnswer，选中选项设置选项为正确答案
 * preview： 预览题目，非编辑状态，可切换选项，修改字段answer，但不保存选项结果
 * exam：考试页面，非编辑状态，可切换选项，修改字段answer，保存选项结果
 * examResult：考试提交后页面，非编辑状态，不可切换选项
 */

//题目组件
function Question(props) {
  const [forceRender, setForceRender] = useState(-1); //强制渲染
  const [dataInfo, setDataInfo] = useState([]); //题目数据信息
  const [editOptionModalVisable, setEditOptionModalVisable] = useState(""); //批量编辑选项弹窗是否展示
  const [answerModalVisable, setAnswerOptionModalVisable] = useState(""); //答案解析弹窗是否展示
  const [batchOptionsValue, setBatchOptionsValue] = useState(); //批量编辑选项弹窗值存储
  const [answerTipsValue, setAnswerTipsValue] = useState(); //答案解析弹窗值存储

  const QuestionTypeList = [
    { type: 1, name: intl.get("be0ecb2d-4d1f-22ca-91e6-59ee7d226516") },
    { type: 2, name: intl.get("93dc9fd5-4c98-2177-8224-e592b911dc03") },
  ];
  useEffect(() => {
    //默认标题编辑状态
    if (props.canEdit) {
      document.getElementById(`title${props.index}`).focus();
    }
  }, []);

  useEffect(() => {
    setDataInfo(cloneDeep(props.data));
  }, [props.data]);

  const handleOptionClickEvent = (e) => {
    const large =
      screen.availWidth <= window.innerWidth &&
      screen.availHeight - 150 <= window.innerHeight;
    if (!large && props.isLargeJudge) {
      e.stopPropagation();
      e.preventDefault();
      props.largeJudge();
      return;
    }
  };

  //选项变换事件
  const handleOptionChangeEvent = (operateType, index, key, value) => {
    if (props.canEdit) {
      //是否可编辑
      const options = dataInfo.options;
      if (operateType === "change") {
        if (key === "checked") {
          if (dataInfo.type === 1) {
            options.map((option) => (option.correctAnswer = 0));
            options[index].correctAnswer = 1;
          } else {
            const isCorrect = options[index].correctAnswer;
            if (isCorrect === 0) {
              options[index].correctAnswer = 1;
            } else if (isCorrect === 1) {
              options[index].correctAnswer = 0;
            }
          }
        } else {
          options[index][key] = value;
        }
      }
      if (operateType === "add") {
        options.push({
          title: `${intl.get("132f6300-dcef-2be4-9b80-88d645bec64b")}${
            dataInfo.options.length + 1
          }`,
          value: dataInfo.options.length + 1,
          correctAnswer: 0,
        });
      }
      if (operateType === "delete") {
        options.splice(index, 1);
      }
      props.changeQuestion(props.index, "change", "options", options);
    } else if (props.status === "preview") {
      //预览不需要保存选项答案
      const options = dataInfo.options;
      if (operateType === "change") {
        options[index][key] = value;
      }
    } else if (props.status === "exam") {
      //用于判断是否全屏答题
      handleOptionClickEvent();
      //考试需要保存选项答案
      const options = dataInfo.options;
      if (operateType === "change") {
        if (key === "answer") {
          if (dataInfo.type === 1) {
            options.map((option) => (option.answer = false));
            options[index].answer = true;
          } else {
            const isCorrect = options[index].answer;
            if (!isCorrect) {
              options[index].answer = true;
            } else if (isCorrect) {
              options[index].answer = false;
            }
          }
        }
      }
      props.changeQuestion(props.index, "change", "options", options);
    }
  };

  //修改题目类型
  const handleChangeEvent = (key, e) => {
    props.changeQuestion(props.index, "change", key, e);
  };

  //获取可编辑/不可编辑样式
  const getClassName = () => {
    if (props.canEdit) {
      return "editWrap";
    }
    return "disableWrap";
  };

  //批量编辑
  const batchEdit = () => {
    if (props.canEdit) {
      let optionString = "";
      dataInfo.options.map((option) => {
        optionString += `${option.title}\n`;
      });
      setBatchOptionsValue(optionString);
      setEditOptionModalVisable(true);
    }
  };

  //批量编辑事件提交
  const handleBatchEditOption = () => {
    const list = batchOptionsValue?.split("\n");
    const optionList = [];
    let flag = true;
    //如果只是新增选项，那原有选项的正确选项以及资源保留
    dataInfo.options.map((option, i) => {
      if (option.title.trim() !== "") {
        if (option.title !== list[i]) {
          flag = false;
        }
      }
    });
    list.map((title, i) => {
      if (flag && i < dataInfo.options.length) {
        optionList.push(dataInfo.options[i]);
      } else if (title.trim() !== "") {
        let option = {
          title: title,
          value: title,
          correctAnswer: 0, //重新编辑后，value赋值为title。置空选中的正确答案，以防赋值后引起错误问题
        };
        optionList.push(option);
      }
    });
    props.changeQuestion(props.index, "change", "options", optionList);
    setEditOptionModalVisable(false);
  };

  //答案解析
  const answerTips = () => {
    if (props.canEdit) {
      setAnswerTipsValue(dataInfo.answerAnalysis);
      setAnswerOptionModalVisable(true);
    }
  };

  //添加题目或者选项图片\音频\视频等资源
  const handleUpload = (fileList, type, i) => {
    console.log("Aliyun OSS:", fileList);
    if (type === "option") {
      dataInfo.options[i].titleResources = fileList;
      props.changeQuestion(props.index, "change", "options", dataInfo.options);
    } else {
      const list = dataInfo.titleResources ?? [];
      list.concat(fileList);
      handleChangeEvent("titleResources", fileList);
    }
  };

  /**
   * 删除题目或选项的其中一个资源
   * @param {当前操作选项数据} type
   * @param {当前操作选项在资源中下标} i
   * @param {当前操作选项的资源在option中下标} oi
   */
  const deleteOptionResource = (type, i, oi) => {
    if (type === "option") {
      const option = dataInfo.options[oi];
      // option.titleResources.splice(oi, 1);
      //选项仅允许一个资源
      option.titleResources = [];
      props.changeQuestion(props.index, "change", "options", dataInfo.options);
    } else {
      dataInfo.titleResources.splice(i, 1);
      handleChangeEvent("titleResources", dataInfo.titleResources);
    }
  };

  /**
   * 渲染预览资源
   * @param {当前操作类型} type
   * @param {当前操作选项在optionList中下标} oi
   * @returns
   */
  const renderResourcePrewiew = (type, oi) => {
    let resourceList = [];
    if (type === "option") {
      resourceList = dataInfo.options[oi].titleResources;
    } else {
      // document.getElementById(`resourceTitleAudio${dataInfo.index}`).innerHTML = "";
      resourceList = dataInfo.titleResources;
    }
    return resourceList?.map((resource, i) => {
      if (ImageTypeList.includes(resource.type)) {
        if (type === "option") {
          if (props.canEdit) {
            return (
              <span className="hoverShowDelete">
                <Image width="100%" src={resource.url} />
                <span
                  className="sourceDelete clickStyle"
                  onClick={() => deleteOptionResource(type, i, oi)}
                >
                  <CloseCircleFilled style={{ color: "#F35C2A" }} />
                </span>
              </span>
            );
          }
          return (
            <span className="previewResource">
              <Image width="100%" src={resource.url} />
            </span>
          );
        } else {
          if (props.canEdit) {
            return (
              <span className="titleImageWrap">
                <span className="hoverShowDelete">
                  <Image width="100%" src={resource.url} />
                  <span
                    className="sourceDelete clickStyle"
                    onClick={() => deleteOptionResource(type, i, oi)}
                  >
                    <CloseCircleFilled style={{ color: "#F35C2A" }} />
                  </span>
                </span>
              </span>
            );
          }
          return (
            <span className="titleImageWrap">
              <Image width="100%" src={resource.url} />
            </span>
          );
        }
      }
      if (AudioTypeList.includes(resource.type)) {
        if (type === "option") {
          if (props.canEdit) {
            return (
              <span className="audioWrap fillDom">
                <AudioItem src={resource.url} miniMode />
                <span
                  className="audioSourceDelete clickStyle"
                  onClick={() => deleteOptionResource(type, i, oi)}
                >
                  <CloseCircleFilled style={{ color: "#F35C2A" }} />
                </span>
              </span>
            );
          }
          return (
            <span className="previewResource audioWrap">
              <AudioItem src={resource.url} />
            </span>
          );
        } else {
          if (props.canEdit) {
            return (
              <span className="titleAudioWrap">
                <Wave waveUrl={resource.url} key={`wave-${type}-${i}`} />
                <span
                  className="sourceDelete clickStyle"
                  onClick={() => deleteOptionResource(type, i, oi)}
                >
                  <CloseCircleFilled style={{ color: "#F35C2A" }} />
                </span>
              </span>
            );
          } else {
            return (
              <span className="titleAudioWrap">
                <Wave waveUrl={resource.url} key={`wave-${type}-${i}`} />
              </span>
            );
          }
        }
      }
      if (VideoTypeList.includes(resource.type)) {
        if (props.canEdit) {
          return (
            <span className="titleVideoWrap">
              <video
                width="100%"
                height="100%"
                controls
                controlsList="noplaybackrate nodownload"
              >
                <source src={resource.url} type={resource.type} />
              </video>
              <span
                className="sourceDelete clickStyle"
                onClick={() => deleteOptionResource(type, i, oi)}
              >
                <CloseCircleFilled style={{ color: "#F35C2A" }} />
              </span>
            </span>
          );
        } else {
          return (
            <span className="titleVideoWrap">
              <video
                width="100%"
                height="100%"
                controls
                controlsList="noplaybackrate nodownload"
              >
                <source src={resource.url} type={resource.type} />
              </video>
            </span>
          );
        }
      }
    });
  };

  //渲染题目选项
  const renderOptions = () => {
    return dataInfo.options?.map((option, i) => (
      <Row
        className={
          props.canEdit
            ? "optionRadioWrap"
            : option.titleResources?.length > 0
            ? "optionRadioFlexWrap"
            : "optionRadioFlexNoResourceWrap"
        }
      >
        <Col span={props.canEdit ? 16 : 24}>
          {props.canEdit ? (
            // 编辑状态且当前编辑题目：左侧展示选项标题
            <Input
              readOnly={!props.canEdit}
              className={`optionTitleWrap ${getClassName()}`}
              onChange={(e) =>
                handleOptionChangeEvent("change", i, "title", e.target.value)
              }
              value={option.title}
            />
          ) : (
            <span className="fillDom">
              {/* 非编辑状态：预览、考试、考试答案、编辑状态但非当前编辑题目（左侧展示选择按钮，右侧展示选项标题 */}
              {renderResourcePrewiew("option", i)}
              <input
                key={`optionInput${i}`}
                type={dataInfo.type === 1 ? "radio" : "checkbox"}
                value={option.value}
                disabled={props.status === "examResult"}
                checked={
                  props.status === "preview" ||
                  props.status === "exam" ||
                  props.status === "examResult"
                    ? option.answer
                    : option.correctAnswer === 1
                }
                onClick={(e) => handleOptionClickEvent(e)}
                onChange={(e) =>
                  handleOptionChangeEvent(
                    "change",
                    i,
                    props.status === "preview" ||
                      props.status === "exam" ||
                      props.status === "examResult"
                      ? "answer"
                      : "checked",
                    e.target.checked
                  )
                }
                id={`${props.index}${i}`}
                name={`questionRadio${props.index}`}
              />
              <label className="fontColor" for={`${props.index}${i}`}>
                {option.title}
              </label>
              {/* {(props.status === 'signleEdit' || props.status === 'add') && option.correctAnswer === 1 && <span className="yellowTips">({intl.get("5bc00641-5b58-2f78-8032-d511774da636")})</span>} */}
            </span>
          )}
        </Col>
        {props.canEdit && (
          <Col span={8}>
            {/* 编辑状态且当前编辑题目：右侧展示资源、选项是否被选中、删除按钮*/}
            <div>
              <span className="optionUpload">
                {option.titleResources?.length > 0 ? (
                  <span>{renderResourcePrewiew("option", i)}</span>
                ) : (
                  <Tooltip
                    title={intl.get("039fd135-282b-2eaa-8190-dbc9346ce447")}
                  >
                    <span className="btn mt5">
                      <AliyunOSSUpload
                        key={`option${i}`}
                        maxCount={1}
                        ossData={props.ossData}
                        fileList={option.titleResources}
                        fileType={9}
                        first={"exam"}
                        second={"questionRepo"}
                        // multiple={true}
                        showUploadList={false}
                        callBack={(fileList) =>
                          handleUpload(fileList, "option", i)
                        }
                        isLimted={300}
                      >
                        <CloudUploadOutlined />
                      </AliyunOSSUpload>
                    </span>
                  </Tooltip>
                )}
              </span>
              <Tooltip title={intl.get("894371bd-adcb-28d9-9af4-14172e61b411")}>
                <input
                  className="optionInput"
                  type={dataInfo.type === 1 ? "radio" : "checkbox"}
                  value={option.value}
                  checked={option.correctAnswer === 1}
                  onChange={(e) =>
                    handleOptionChangeEvent(
                      "change",
                      i,
                      "checked",
                      e.target.value
                    )
                  }
                  name={`questionRadio${props.index}`}
                />
              </Tooltip>
              <Tooltip
                title={intl.get("Delete_6c8ad8f4-5190-2a51-8242-801d43794904")}
              >
                <span
                  className="btn mt5 optionDelete"
                  onClick={() => handleOptionChangeEvent("delete", i)}
                >
                  <CloseCircleFilled style={{ color: "#F35C2A" }} />
                </span>
              </Tooltip>
            </div>
          </Col>
        )}
      </Row>
    ));
  };

  const isCorrectAnswer = () => {
    let flag = true;
    (dataInfo.options || []).map((o) => {
      if (
        (o.correctAnswer !== 1 && o.answer) ||
        (o.correctAnswer === 1 && !o.answer)
      ) {
        flag = false;
      }
    });
    return flag;
    //status: 0:没做，1：正确，2：错误
    // return dataInfo.status === 1;
  };

  const getWrapClass = () => {
    let styles = "questionWrap";
    if (props.status === "examResult") {
      if (isCorrectAnswer()) {
        styles += `  successBg`;
      } else {
        styles += `  errorBg`;
      }
    }
    if (props.status === "add") {
      styles += `  add`;
    }
    if (props.canEdit) {
      styles += `  editWrap`;
    }
    return styles;
  };

  const getResultWrapClass = () => {
    let styles = "resultWrap";
    if (props.status === "examResult") {
      if (isCorrectAnswer()) {
        styles += `  resultSuccessWrap`;
      } else {
        styles += `  resultErrorWrap`;
      }
    }
    return styles;
  };

  return (
    <div
      id={`question-${dataInfo.id}`}
      style={{
        display:
          (props.isOnlyShowError && !isCorrectAnswer()) ||
          !props.isOnlyShowError
            ? "block"
            : "none",
      }}
      className={getWrapClass()}
      onClick={() => props.changeEditStatus && props.changeEditStatus(dataInfo)}
    >
      <Row align={"space-between"} className="questionTitleWrap">
        <Col span={props.canEdit ? 19 : 18} className="pointer">
          <b className="verAlignSub">
            {props.index + 1}.
            {props.canEdit ? (
              // 编辑状态且当前编辑题目：标题为编辑状态
              <Input
                id={`title${props.index}`}
                className={`lineWrap ${getClassName()}`}
                onChange={(e) => handleChangeEvent("title", e.target.value)}
                value={dataInfo.title}
              />
            ) : (
              /* 非编辑状态：预览、考试、考试答案、编辑状态但非当前编辑题目 */
              <span>{dataInfo.title} </span>
            )}
          </b>
        </Col>
        <Col
          span={props.canEdit ? 4 : 5}
          className="alignEnd"
          key={`type-${props.index}`}
        >
          {props.canEdit ? (
            // 编辑状态且当前编辑题目
            <Select
              className="select alignLeft"
              value={dataInfo.type}
              onChange={(e) => handleChangeEvent("type", e)}
            >
              {QuestionTypeList?.map((item, index) => {
                return (
                  <Option value={item.type} key={item.type}>
                    {item.name}
                  </Option>
                );
              })}
            </Select>
          ) : (
            /* 非编辑状态：预览、考试、考试答案、编辑状态但非当前编辑题目 */
            <span className="yellowTips">
              <b>
                {
                  QuestionTypeList.find((q) =>
                    dataInfo.type ? q.type === dataInfo.type : q.type === 1
                  ).name
                }
                「{dataInfo.score ?? 0}
                {intl.get("score_4693dfa7-0204-2778-94f8-03b3c9bd43b9")}」
              </b>
            </span>
          )}
        </Col>
      </Row>
      {props.canEdit ? (
        <div>
          {/* 添加资源 */}
          <span className="resourceWrap">
            <span id={`resourceTitleAudio${dataInfo.index}`}></span>
            {dataInfo.titleResources?.length > 0 &&
              renderResourcePrewiew("title")}
          </span>
          <AliyunOSSUpload
            key="question"
            ossData={props.ossData}
            fileList={dataInfo.titleResources}
            fileType={7}
            // multiple={true}
            first={"exam"}
            second={"questionRepo"}
            callBack={(fileList) => handleUpload(fileList, "title")}
            showUploadList={false}
            isLimted={300}
          >
            <Tooltip title={intl.get("d36c3a5c-43e2-2ec6-bb7a-163a212d727a")}>
              <span className="addBtnWrap">
                <PlusOutlined style={{ color: "#1890FF" }} />
                &nbsp;{intl.get("4c84b238-c87d-2273-a247-fabdf56b6867")}
              </span>
            </Tooltip>
          </AliyunOSSUpload>
        </div>
      ) : (
        <div>
          {dataInfo.titleResources?.length > 0 &&
            renderResourcePrewiew("title")}
        </div>
      )}
      {/* 设置正确答案提示 */}
      {props.canEdit && (
        <div className="mt15 tipsColor fs14">
          <Row justify="space-between">
            <Col span={12}>
              {intl.get("5acd3f39-ed28-28eb-a0c4-465450f96aa0")}
              {dataInfo.type === 1 ? (
                <img className="tipIcon" src={radioImg} />
              ) : (
                <img className="tipIcon" src={checkboxImg} />
              )}
              {intl.get("cc688d2b-8a4e-2fc4-ba5e-5201b9245418")}
            </Col>
            <Col span={12}>
              {/* 题目分数 */}
              <div className="alignEnd">
                <span>{intl.get("65dd48a3-0121-25d3-86fa-0744a3973614")}:</span>
                <span className="scoreWrap">
                  <InputNumber
                    readOnly={!props.canEdit}
                    className="scoreInputWrap"
                    min={1}
                    max={100}
                    onChange={(e) => handleChangeEvent("score", e)}
                    value={dataInfo.score}
                  />
                </span>
                <span>
                  {intl.get("score_4693dfa7-0204-2778-94f8-03b3c9bd43b9")}
                </span>
              </div>
            </Col>
          </Row>
        </div>
      )}
      <div className={props.status === "signleEdit" ? "optionsWrap" : ""}>
        {renderOptions()}
      </div>
      {props.canEdit && (
        <Row justify="space-between" className="mt10">
          <Col span={18}>
            {/* 添加选项 */}
            <span
              className="clickStyle"
              onClick={() => handleOptionChangeEvent("add")}
            >
              {intl.get("7f93b139-ad0c-2b7f-8700-d8acfc13e305")}
            </span>
            <Divider type="vertical" />
            {/* 批量编辑 */}
            <span className="clickStyle" onClick={batchEdit}>
              {intl.get("e433d19c-61b2-288e-b799-4f1ee74262db")}
            </span>
            <Divider type="vertical" />
            {/* 答案解析 */}
            <span className="clickStyle" onClick={answerTips}>
              {intl.get("2ac9ebd2-34d3-246b-ae56-691fc72352a6")}
            </span>
          </Col>
          {!props.hideDeleteBtn && (
            <Col span={6} className="alignEnd">
              <Tooltip title={intl.get("b997bb53-14e3-2f30-8539-5afbf4506977")}>
                <span
                  className="pointer"
                  onClick={() => props.changeQuestion(props.index, "delete")}
                >
                  <DeleteTwoTone twoToneColor="red" />
                </span>
              </Tooltip>
            </Col>
          )}
        </Row>
      )}
      {props.status === "examResult" && (
        <div className={getResultWrapClass()}>
          <div>
            {intl.get("3eae2ccb-7c94-2f3a-907e-86fdd362c7f0")}：
            <b className={isCorrectAnswer() ? "successColor" : "errorColor"}>
              {isCorrectAnswer()
                ? intl.get("1e60bc7e-2609-2e26-991d-8c0212541dd0")
                : intl.get("62e1e42b-048c-2701-b466-1469a3d3d97a")}
            </b>
          </div>
          <div>
            {/* 正确答案 */}
            {intl.get("5bc00641-5b58-2f78-8032-d511774da636")}：
            {dataInfo.options
              .filter((o) => o.correctAnswer === 1)
              .map((item) => `${item.title}；`)}
          </div>
          <div>
            {/* 答案解析 */}
            {intl.get("2ac9ebd2-34d3-246b-ae56-691fc72352a6")}：
            {dataInfo.answerAnalysis ??
              intl.get("2c2ddaef-39e6-2158-a0b6-df3e2123ce42")}
          </div>
        </div>
      )}
      {/* 批量编辑题目选项弹窗 */}
      <Modal
        open={editOptionModalVisable}
        title={intl.get("94ea429b-d325-2cc0-87fe-a7efad04cefe")}
        onCancel={() => setEditOptionModalVisable(false)}
        centered
        maskClosable={false}
        footer={null}
        bodyStyle={{
          padding: 20,
        }}
      >
        <TextArea
          placeholder={intl.get("694fff0e-e9d6-2858-ba17-8eaa816db75a")}
          value={batchOptionsValue}
          onChange={(e) => {
            setBatchOptionsValue(e.target.value);
          }}
          autoSize={{ maxRows: 5 }}
        />
        <div className="buttonGroup">
          <Button onClick={() => setEditOptionModalVisable(false)}>
            {intl.get("Cancel_51f2be22-0a99-2045-95f1-81feae4ea69d")}
          </Button>
          <Button type="primary" onClick={handleBatchEditOption}>
            {intl.get("Submit_b4c78c66-cc86-21f2-9581-710c4b1acf9b")}
          </Button>
        </div>
      </Modal>
      {/* 答案解析弹窗 */}
      <Modal
        open={answerModalVisable}
        title={intl.get("2ac9ebd2-34d3-246b-ae56-691fc72352a6")}
        onCancel={() => setAnswerOptionModalVisable(false)}
        centered
        maskClosable={false}
        footer={null}
        bodyStyle={{
          padding: 20,
        }}
      >
        <TextArea
          value={answerTipsValue}
          maxLength={500}
          maxRows={5}
          showCount
          onChange={(e) => {
            setAnswerTipsValue(e.currentTarget.value);
          }}
          autoSize={{ maxRows: 5 }}
        />
        <div className="buttonGroup">
          <Button onClick={() => setAnswerOptionModalVisable(false)}>
            {intl.get("Cancel_51f2be22-0a99-2045-95f1-81feae4ea69d")}
          </Button>
          <Button
            type="primary"
            onClick={() => {
              props.changeQuestion(
                props.index,
                "change",
                "answerAnalysis",
                answerTipsValue
              );
              setAnswerOptionModalVisable(false);
            }}
          >
            {intl.get("Submit_b4c78c66-cc86-21f2-9581-710c4b1acf9b")}
          </Button>
        </div>
      </Modal>
    </div>
  );
}
export default Question;
